import { Route, Routes } from 'react-router-dom'
import { EntregaMotorista } from '../pages/StatusPedidos/EntregaMotorista'

import { VisualizarEtiqueta } from '../pages/StatusPedidos/VisualizarEtiqueta'
import { PedidosAntecipados } from '../pages/StatusPedidos/PedidosAntecipados'
import { GerarEtiqueta } from '../pages/StatusPedidos/GerarEtique'
import { RastreioJ3 } from '../pages/RastreioJ3'
import { ControleCompreGanheProducao } from '../pages/StatusPedidos/ControleCompreGanheProducao'
import { Producao360 } from '../pages/StatusPedidos/Producao360'
import { ControleIlustracao } from '../pages/StatusPedidos/ControleIlustracao'
import { ControleIlustracaoProvider } from '../contexts/ControleIlustracaoProvider'
import { Producao360Provider } from '../contexts/Producao360Provider'
import { RecebimentoDeConsumo } from '../pages/Financeiro/RecebimentoDeConsumo'
import { RelatorioDeTroca } from '../pages/StatusPedidos/RelatorioDeTroca'
import { IdNota } from '../pages/StatusPedidos/idnota'
import { AprovacaoPiloto } from '../pages/StatusPedidos/AprovacaoPiloto'
import { ItensPedido } from '../pages/StatusPedidos/ItensPedido'
import { RecebimentoTroca } from '../pages/StatusPedidos/RecebimentoTroca'
import { SolicitarTroca } from '../pages/StatusPedidos/SolicitarTroca'

export function RouteStatusPedido() {
  return (
    <Routes>
      <Route path="/:id/:sequency" element={<IdNota />} />
      <Route path="/:id/:sequency/aprovacao-piloto" element={<AprovacaoPiloto />} />
      <Route path="/:id/:sequency/itens-pedido" element={<ItensPedido />} />
      <Route path="/:id/:sequency/recebimento-troca" element={<RecebimentoTroca />} />
      <Route path="/:id/:sequency/solicitar-troca" element={<SolicitarTroca />} />
      <Route path="/itens-pedido" element={<ItensPedido />} />
      <Route path="/recebimento-troca" element={<RecebimentoTroca />} />
      <Route path="/solicitar-troca" element={<SolicitarTroca />} />
      <Route path="/entrega-motorista" element={<EntregaMotorista />} />
      <Route path="/visualizar-etiqueta" element={<VisualizarEtiqueta />} />
      <Route path="/pedidos-antecipados" element={<PedidosAntecipados />} />
      <Route path="/gerar-etiqueta" element={<GerarEtiqueta />} />
      <Route path="/rastreio-j3" element={<RastreioJ3 />} />
      <Route path="/controle-compre-ganhe" element={<ControleCompreGanheProducao />} />
      <Route
        path="/producao-360"
        element={
          <Producao360Provider>
            <Producao360 />
          </Producao360Provider>
        }
      />
      <Route
        path="/controle-ilustracao"
        element={
          <ControleIlustracaoProvider>
            <ControleIlustracao />
          </ControleIlustracaoProvider>
        }
      />

      <Route path="/recebimento-de-consumo" element={<RecebimentoDeConsumo />} />
      <Route path="/relatorio-de-troca" element={<RelatorioDeTroca />} />
    </Routes>
  )
}
